import { render, staticRenderFns } from "./message-timestamp.vue?vue&type=template&id=5ed6af21&scoped=true"
import script from "./message-timestamp.vue?vue&type=script&lang=ts"
export * from "./message-timestamp.vue?vue&type=script&lang=ts"
import style0 from "./message-timestamp.vue?vue&type=style&index=0&id=5ed6af21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6af21",
  null
  
)

export default component.exports